import { ApiError } from '@/api/client';
import { showErrorToast } from '@/lib/toasts';

/**
 * A route this Hangar does not serve yet: the API answers 501 `HGR-NOT-IMPLEMENTED` for what exists only in its
 * contract. Forms show this instead of a generic error.
 */
export function notAvailableYet(e: unknown): Error | null {
  return e instanceof ApiError && e.status === 501 ? new Error(`Not available yet on this Hangar (${e.code}): ${e.message}`) : null;
}

/**
 * Toast for a write that failed outside a form field (archive, enable, test): a 412 means someone changed the record
 * since the list loaded (the hooks reload it), a 403 names the missing permission, a 501 says the feature is not
 * available yet, anything else keeps its code and request id.
 */
export function showMutationError(e: unknown, fallback: string): void {
  if (e instanceof ApiError && e.status === 501) {
    showErrorToast({ title: 'Not available yet', description: `${e.code} · ${e.message}` });
    return;
  }
  if (e instanceof ApiError && e.status === 412) {
    showErrorToast({ title: 'It changed since this page loaded', description: 'The list was reloaded: review it and try again.' });
    return;
  }
  if (e instanceof ApiError && e.status === 403) {
    showErrorToast({ title: 'You are not allowed to do this', description: `${e.code} · ${e.message}` });
    return;
  }
  showErrorToast(e instanceof ApiError ? { title: e.toastTitle, description: `${e.code} · ${e.message}` } : { title: fallback, description: e instanceof Error ? e.message : undefined });
}
